import { Injectable, Inject } from '@angular/core'
import { DOCUMENT } from '@angular/common'

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private currentTheme = ''

  themes: { [name: string]: string; } = {};



  constructor(@Inject(DOCUMENT) private document: Document) {
    // ubie theme
    this.themes['ubie'] = `
    ${this.currentTheme}
    --ion-color-primary: #69a8d2;
    --ion-color-primary-rgb: 105, 168, 210;
    --ion-color-primary-shade: #5c94b9;
    --ion-color-primary-tint: #78b1d7;
    --ion-toolbar-border-color: #5a96bd;
    `;

    // qbus theme
    this.themes['qbus'] = `
    ${this.currentTheme}
    --ion-color-primary: #FFAD26  ;
    --ion-color-primary-rgb: 255, 173, 38;
    --ion-color-primary-shade: #e09821;
    --ion-color-primary-tint: #ffb53c;   
    --ion-toolbar-border-color: #E9A31F;
    `
  }

  setTheme(name: string) {
    this.document.documentElement.style.cssText = this.themes[name];
  }



}